module.exports = __webpack_public_path__ + "static/assets/9d24236e78cf598bbe2ebabbd1860c57.png";